// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"228":"i18nChunkB","431":"i18nChunkA","621":"i18nChunkC"}[chunkId] + ".js";
};